// extracted by mini-css-extract-plugin
export default {"draggableArea":"gqhJvPg7o72xJxKaLMsP","overlay":"sPSCwHSz1wT1EtH1CJPW","card":"io9K23FQaNAr8Sb3a4FK","app":"av7OinAcYPBoaKiGn0K5","cover":"vYHPNajoiKlhM1rs_OfK"};